import { render, staticRenderFns } from "./UsersHeader.vue?vue&type=template&id=533d3ebc"
import script from "./UsersHeader.vue.ts?vue&type=script&lang=ts&external"
export * from "./UsersHeader.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports